// Utilitário para testar conexão com o backend
export const testBackendConnection = async () => {
  try {
    // Primeiro testar diretamente o backend (sem proxy)
    console.log('Testando conexão direta com backend...')
    const directResponse = await fetch('http://localhost:3001/api/status/quotation-statuses', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    
    if (directResponse.ok) {
      console.log('✅ Conexão direta com backend funcionando!')
      return {
        success: true,
        status: directResponse.status,
        message: 'Backend conectado diretamente'
      }
    }
  } catch (directError) {
    console.log('❌ Conexão direta falhou:', directError.message)
  }
  
  try {
    // Testar via proxy do Vite
    console.log('Testando via proxy do Vite...')
    const response = await fetch('/api/status/quotation-statuses', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    
    console.log('Backend connection test:', {
      status: response.status,
      ok: response.ok,
      url: response.url
    })
    
    return {
      success: response.ok,
      status: response.status,
      message: response.ok ? 'Conexão OK' : `Erro HTTP: ${response.status}`
    }
  } catch (error) {
    console.error('Connection test failed:', error)
    return {
      success: false,
      error: error.message,
      message: 'Falha na conexão com o backend'
    }
  }
}

export const testAuthEndpoint = async (credentials) => {
  try {
    // Usar proxy do Vite para evitar CORS
    const response = await fetch('/api/auth/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(credentials)
    })
    
    const data = await response.json().catch(() => ({}))
    
    console.log('Auth test:', {
      status: response.status,
      ok: response.ok,
      data
    })
    
    return {
      success: response.ok,
      status: response.status,
      data,
      message: response.ok ? 'Auth endpoint OK' : `Erro: ${data.message || response.status}`
    }
  } catch (error) {
    console.error('Auth test failed:', error)
    return {
      success: false,
      error: error.message,
      message: 'Falha no teste de autenticação'
    }
  }
}
